import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { ContactSiteData } from './contactSite.api'
import { UserData } from './user.api'

export interface VendorData {
  id: number
  siteId: number
  createdBy: number
  updatedBy: number
  deletedBy?: number
  name: string
  deletedAt?: string
  createdAt: string
  updatedAt: string
  isDeleted: boolean
  updatedUser?: UserData
}

const routes = {
  search: '/vendors/search',
  listSites: '/vendors/{id}/sites'
}

export default {
  search (vendor: string, callback: ResponseCallback<VendorData[]>) {
    const params = { vendor }
    api.get(routes.search, params, callback)
  },

  listSites (id: number, callback: ResponseCallback<ContactSiteData[]>) {
    const url = routeUtil.replaceParams(routes.listSites, { id })
    api.get(url, {}, callback)
  }
}
